import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-list-1-6-0{margin:0 0 12px;padding-left:12px;list-style-type:none}.hcr-list-1-6-0 .hcr-list-1-6-0{margin:0;padding-left:0}.hcr-list__item-1-6-0{position:relative;padding-left:16px;line-height:1.375em}.hcr-list__item-1-6-0:before{display:block;position:absolute;top:.6875em;left:0;width:4px;height:4px;margin-top:-2px;margin-right:12px;border-radius:50%;background:#444;content:\"\"}.hcr-list-simple-1-6-0{margin:0;padding-left:0;list-style-type:none}.hcr-list-simple__item-1-6-0{min-height:40px;padding:8px 0;border-bottom:1px solid #e1e1e1;color:#444;font-size:16px}.hcr-list-simple__item-1-6-0:last-child{border-bottom:0}.hcr-list-linked-1-6-0{margin:0;padding-left:0;list-style-type:none}.hcr-list-linked__item-1-6-0{position:relative;border-bottom:1px solid #e1e1e1}.hcr-list-linked__item-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M365.9 763.6a28.2 28.2 0 010-40.4l216.4-216.4a8.2 8.2 0 000-13.6L365.9 276.8a28.6 28.6 0 0140.5-40.4l216.3 218.1a66.4 66.4 0 0119.6 45.5 66.4 66.4 0 01-19.6 45.5L406.4 763.6a28.2 28.2 0 01-40.5 0z' fill='rgba(51, 51, 51, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;position:absolute;top:50%;right:12px;margin-top:-11px}.hcr-list-linked__item-1-6-0:active,.hcr-list-linked__item-1-6-0:focus,.hcr-list-linked__item-1-6-0:hover{border-radius:5px;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12)}.hcr-list-linked__item-1-6-0:last-child{border-bottom:0}.hcr-list-linked-1-6-0 a,.hcr-list-linked__link-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;width:100%;height:60px;padding:5px 24px 5px 12px;color:#444;font-size:16px;font-weight:400;text-decoration:none;cursor:pointer}.hcr-list-linked-1-6-0 a:active,.hcr-list-linked-1-6-0 a:focus,.hcr-list-linked-1-6-0 a:hover,.hcr-list-linked__link-1-6-0:active,.hcr-list-linked__link-1-6-0:focus,.hcr-list-linked__link-1-6-0:hover{text-decoration:none}.hcr-list-numbered-1-6-0{margin:0 0 12px;padding-left:12px;list-style-type:none;counter-reset:numbered-list-counter}.hcr-list-numbered__item-1-6-0{display:table;position:relative}.hcr-list-numbered__item-1-6-0:before{display:table-cell;padding-right:6px;font-weight:700;content:counters(numbered-list-counter,\".\") \".\";counter-increment:numbered-list-counter}.hcr-list-numbered-1-6-0 .hcr-list-numbered-1-6-0{width:100%;margin:0;padding-left:0}.hcr-list-numbered-1-6-0 .hcr-list-numbered-1-6-0 .hcr-list-numbered__item-1-6-0:before{font-weight:300;content:counters(numbered-list-counter,\".\")}",
map:{"hcr-list":"hcr-list-1-6-0","hcr-list__item":"hcr-list__item-1-6-0","hcr-list-simple":"hcr-list-simple-1-6-0","hcr-list-simple__item":"hcr-list-simple__item-1-6-0","hcr-list-linked":"hcr-list-linked-1-6-0","hcr-list-linked__item":"hcr-list-linked__item-1-6-0","hcr-list-linked__link":"hcr-list-linked__link-1-6-0","hcr-list-numbered":"hcr-list-numbered-1-6-0","hcr-list-numbered__item":"hcr-list-numbered__item-1-6-0"}};

var List = function List(_ref) {
  var appearance = _ref.appearance,
      extraClasses = _ref.extraClasses,
      children = _ref.children,
      content = _ref.content,
      rest = _objectWithoutProperties(_ref, ["appearance", "extraClasses", "children", "content"]);

  // initialises classname depending on appearence as we import several scss partials
  var cssClass = appearance ? "list-".concat(appearance) : 'list';
  var bem = Bem(cssClass, styles); // switch type of list depending on appearance

  var ListType = appearance === 'numbered' ? 'ol' : 'ul'; // use content prop or fall back to children

  var nest = content || children;
  var listItems = [];

  for (var i = 0; i < nest.length; i += 1) {
    // deconstruct current nested item
    var _nest$i = nest[i],
        key = _nest$i.key,
        text = _nest$i.text,
        href = _nest$i.href,
        sub = _nest$i.sub,
        RouterLink = _nest$i.RouterLink,
        restChild = _objectWithoutProperties(_nest$i, ["key", "text", "href", "sub", "RouterLink"]); // if list is a linked one


    if (appearance === 'linked') {
      // if text is provided embed in link
      // otherwise display child (this allows passing custom anchors)
      listItems.push(React.createElement("li", {
        key: key || i,
        className: bem.e('item')
      }, text && (RouterLink ? React.createElement(RouterLink, _extends({
        to: href,
        className: bem.e('link')
      }, restChild), text) : React.createElement("a", _extends({
        className: bem.e('link'),
        href: href
      }, restChild), text)), !text && nest[i])); // we can skip the rest

      continue; // eslint-disable-line
    } // all other appearances
    // recurse if sub property is preset on child


    listItems.push(React.createElement("li", {
      key: key || i,
      className: bem.e('item')
    }, text || nest[i], sub && (appearance === null || appearance === 'numbered') && List({
      content: sub,
      appearance: appearance
    })));
  } // done


  return React.createElement(ListType, _extends({
    className: bem.b(false, extraClasses)
  }, rest), listItems);
};
List.displayName = 'List';
List.defaultProps = {
  appearance: null,
  extraClasses: '',
  content: null,
  children: []
};
var contentProps = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
  text: PropTypes.node,
  key: PropTypes.string,
  href: PropTypes.string,
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}), PropTypes.string]));
contentProps.sub = contentProps;
List.propTypes = {
  /** appearance */
  appearance: PropTypes.oneOf([null, 'simple', 'linked', 'numbered']),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Content, for nested items */
  content: contentProps,
  // @todo deprecate content prop

  /** Children, fallback for nested items */
  children: contentProps
};
var list = Injecss(List, styles);

export { list as List };
